module.exports = __webpack_public_path__ + "static/media/caseBg1.02717634.png";